// Texto enriquecido de las características (solo negrita / cursiva / subrayado).
// Formato de guardado: líneas separadas por "\n"; cada línea puede llevar inline
// <b>/<i>/<u>. Retrocompatible con el texto plano antiguo (líneas sin formato).
// El saneado (whitelist) se aplica tanto al serializar el editor como al pintar,
// así que el HTML almacenado nunca ejecuta nada arbitrario.

const INLINE_MAP: Record<string, 'b' | 'i' | 'u'> = {
  B: 'b', STRONG: 'b', I: 'i', EM: 'i', U: 'u',
}

function escapeHtml(s: string): string {
  return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
}

/** HTML inline seguro de los hijos de un nodo: conserva solo <b>/<i>/<u>
 *  (mapea strong→b, em→i), desenrolla el resto y escapa el texto. */
function inlineOf(node: Node): string {
  let out = ''
  node.childNodes.forEach((child) => {
    if (child.nodeType === Node.TEXT_NODE) {
      out += escapeHtml(child.textContent ?? '')
    } else if (child.nodeType === Node.ELEMENT_NODE) {
      const el = child as Element
      const tag = INLINE_MAP[el.tagName]
      const inner = inlineOf(el)
      if (!inner) return
      out += tag ? `<${tag}>${inner}</${tag}>` : inner
    }
  })
  return out
}

/** Editor (ul contentEditable) → formato de guardado (líneas "\n" con inline b/i/u). */
export function serializeEditorUl(ul: HTMLElement): string {
  const lines: string[] = []
  ul.childNodes.forEach((node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      lines.push(escapeHtml(node.textContent ?? ''))
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      // <li> (lo normal) o cualquier bloque que algún navegador inserte → una línea
      lines.push(inlineOf(node))
    }
  })
  return lines.map((l) => l.trim()).filter(Boolean).join('\n')
}

/** Contenido guardado (texto plano antiguo o HTML nuevo) → items <li> saneados,
 *  para pintar (vista/impresión) y para inicializar el editor. */
export function caracLisHtml(stored: string): string {
  const text = (stored || '').replace(/\r\n/g, '\n')
  if (!text.trim()) return ''
  const tmp = document.createElement('div')
  return text
    .split('\n')
    .map((line) => {
      const trimmed = line.trim()
      if (!trimmed) return ''
      tmp.innerHTML = trimmed          // parseo aislado (no ejecuta scripts, div desconectado)
      const safe = inlineOf(tmp)       // whitelist b/i/u + escape
      return safe ? `<li>${safe}</li>` : ''
    })
    .filter(Boolean)
    .join('')
}
